import { motion } from "framer-motion";
import { useI18n } from "../lib/i18n";
import { Reveal, Eyebrow, fadeUp } from "../components/Motion";

export default function Approach() {
  const { t } = useI18n();
  return (
    <div className="pt-32" data-testid="approach-page">
      <section className="px-6 md:px-10">
        <div className="max-w-[1400px] mx-auto">
          <Eyebrow>{t.approach.eyebrow}</Eyebrow>
          <motion.h1
            {...fadeUp}
            className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-light tracking-tighter leading-[1.02] mt-6 max-w-5xl"
          >
            {t.approach.title}
          </motion.h1>
          <motion.p
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="text-lg sm:text-xl text-[#4A4D4A] mt-8 max-w-2xl leading-relaxed"
          >
            {t.approach.lead}
          </motion.p>
        </div>
      </section>

      <section className="mt-20 sm:mt-28 px-6 md:px-10">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
          {t.approach.pillars.map((p, i) => (
            <Reveal key={p.t} delay={i * 0.08}>
              <div className="h-full p-10 bg-white border border-[#EBEAE0] rounded-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500">
                <div className="font-mono text-xs text-[#A6192E] tracking-wider">0{i + 1}</div>
                <h3 className="font-display text-2xl sm:text-3xl text-[#1A1A1A] mt-5 tracking-tight">
                  {p.t}
                </h3>
                <p className="text-sm sm:text-base text-[#4A4D4A] mt-4 leading-relaxed">{p.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mt-32 px-6 md:px-10">
        <div className="max-w-[1400px] mx-auto bg-[#F3F2EB] rounded-sm p-12 sm:p-20">
          <Eyebrow color="green">Lifecycle</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter mt-6 max-w-3xl text-[#1A1A1A]">
            We are reliable partners — across the full lifecycle of an investment.
          </h2>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-4 gap-1">
            {["Origination", "Investment", "Active ownership", "Lasting value"].map(
              (s, i) => (
                <Reveal key={s} delay={i * 0.07}>
                  <div className="p-7 bg-white border border-[#EBEAE0]">
                    <div className="font-mono text-xs text-[#A6192E]">0{i + 1}</div>
                    <div className="font-display text-lg sm:text-xl text-[#1A1A1A] mt-3 tracking-tight">
                      {s}
                    </div>
                  </div>
                </Reveal>
              )
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
